import styled from "styled-components";

export const ContainerMenu = styled.div<{ $open: Boolean }>`
  grid-area: sidebar;
  /* background-color: ${({ theme }) => theme.menu.main}; */
  background: linear-gradient(${({ theme }) => theme.menu.main}, #3b668f);
  width: ${(props) => (props.$open ? "200px" : "60px")};
  transition: all 0.3s ease-in-out;
  max-height: max-content;
  height: 100vh;
  display: grid;
  grid-template-rows: 50px 1fr 80px;
  flex-direction: column;
  border-right: ${({ theme }) =>
    theme.menu.main == "#112233" ? "1px solid #223547" : "1px solid #ccc"};

  p {
    transition: 300ms ease-in all;
    display: ${(props) => (props.$open ? "inherit" : "none")};
    scale: ${(props) => (props.$open ? 1 : 0)};
  }

  .footer {
    display: ${(props) => (props.$open ? "inherit" : "none")};
  }

  ul {
    max-width: ${(props) => (props.$open ? "inherit" : "min-content")};
    li {
      img:nth-child(2) {
        display: ${(props) => (props.$open ? "inherit" : "none")};
      }
    }
  }

  @media (max-width: 800px) {
    transform: ${(props) =>
      props.$open ? "translateX(0px)" : "translate(-60px)"};
    position: absolute;
    z-index: 8;
  }
`;

export const ButtonRotina = styled.li`
  padding: 5px;
  cursor: pointer;
  font-weight: 500;
  letter-spacing: 1.2px;
  z-index: 888;
`;

export const Organize = styled.div<{ active?: boolean | any }>`
  display: flex;
  padding: 0px 4px;
  position: relative;
  align-items: center;
  border-radius: 8px;
  border: ${(props) => (props?.active ? "1px solid #084662" : false)};
  background-color: ${(props) => (props?.active ? "#084662" : "inherit")};
  box-shadow: ${(props) =>
    props?.active ? "5px 5px 1px rgba(10, 6, 6, 0.3)" : "inherit"};

  * > p {
    font-size: 12px;
  }

  &:hover {
    background-color: #084662;
  }

  image {
    border: ${(props) => (props?.active ? "none" : "inherit")};
  }
`;

export const Agrup = styled.div`
  display: flex;
  place-items: center;
  gap: 4px;
  flex: 1;
  padding: 4px 0;
`;

export const SubAgrup = styled.ul`
  margin-top: 8px;
  border-radius: 5px;
  list-style: none;
  margin-left: 8px;
  transition: all 0.3s ease-in-out;
  animation: openSubGrup 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  row-gap: 5px;

  @keyframes openSubGrup {
    0% {
      height: 0;
      opacity: 0;
      scale: 0;
    }

    100% {
      opacity: 100%;
      scale: 1;
      height: fit-content;
      max-height: max-content;
    }
  }
`;

export const SubMenu = styled.li`
  line-height: 50px;
  padding-left: 5%;

  &:hover {
    background-color: #616263;
    border-radius: 5px;
  }
`;

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 15px;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;

  &:before {
    position: absolute;
    content: "🌗";
    display: flex;
    align-items: center;
    justify-content: center;
    height: 26px;
    width: 26px;
    left: 4px;
    border-radius: 15px;
    bottom: 4px;
    background-color: #fff;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
`;
export const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
`;

export const Input = styled.input`
  &:checked + span {
    background-color: #2196f3;
    width: 60px;
  }

  &:checked + span::before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  &:focus + span {
    box-shadow: 0 0 1px #2196f3;
  }
`;

export const SliderRound = styled.div`
  border-radius: 34px;

  &::before {
    border-radius: 50%;
  }
`;

export const ContainerSwitchTheme = styled.div`
  height: 100%;
  width: max-content;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Icon = styled.img`
  max-height: 30px;
  max-width: 30px;
  border-radius: 4px;
  padding: 8px;
  background: #084662;
  border: 1px solid #6b6b6b63;
`;

export const Seta = styled.img<{ active: boolean }>`
  width: 10px;
  transition: all ease-in 300ms;
  transform: ${({ active }) => (active ? "rotate(180deg)" : null)};
`;

export const SideBarHeader = styled.div`
  border-bottom: ${({ theme }) =>
    theme.menu.main == "#112233" ? "1px solid #223547" : "1px solid #ccc"};
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    width: 150px;
    filter: brightness(100);
  }
`;

export const SideBar = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 5px;
  justify-items: center;
  overflow-y: auto;
  list-style: none;
  color: white;
  font-weight: lighter;

  & li {
    border-radius: 8px;
  }
`;

export const SideBarFooter = styled.div`
  display: flex;

  & > * {
    list-style: none;
  }
`;
